import { z } from "zod";
import { twinGovernedQueryFilterSchema, twinGovernedQueryMetricSchema } from "./twin-governed-query.js";
const identifier = z.string().trim().min(1).max(200);
const value = z.string().max(4_000).nullable();
/**
 * Which figure's records to read: one of the run's own governed aggregate queries, a row of its
 * result and the metric in that row. The filters come from the run, never from the request.
 */
export const getTaskRunAnswerRecordsQuerySchema = z.object({
    runId: identifier,
    toolCallId: identifier,
    queryId: identifier,
    // A query string gives the row as digits; a missing or empty one is refused, never read as row 0.
    row: z.union([z.number(), z.string().regex(/^\d{1,5}$/u).transform(Number)]).pipe(z.number().int().nonnegative().max(10_000)),
    column: identifier,
}).strict();
/** At most this many records are listed; `total` counts them all. */
export const RUN_ANSWER_RECORDS_LIMIT = 200;
/**
 * The records behind a figure in a run's answer: the governed product's rows that the figure's
 * query summed, selected by its filters and its row's group values (`criteria`). They are read now,
 * as the reader, from the product's active version, so `figure` gives both what the answer showed
 * and the same metric over these records: they differ when the data or the product has moved.
 */
export const runAnswerRecordsSchema = z.object({
    schemaVersion: z.literal("mlx.run-answer-records.v1"),
    runId: identifier,
    toolCallId: identifier,
    product: z.object({
        slug: identifier,
        version: z.number().int().positive(),
        answerVersion: z.number().int().positive().optional(),
    }).strict(),
    criteria: z.array(twinGovernedQueryFilterSchema).max(64),
    fields: z.array(z.object({ field: identifier, role: z.enum(["dimension", "measure"]) }).strict()).min(1).max(64),
    rows: z.array(z.record(z.string(), value)).max(RUN_ANSWER_RECORDS_LIMIT),
    total: z.number().int().nonnegative(),
    figure: z.object({
        column: identifier,
        metric: twinGovernedQueryMetricSchema,
        answered: value,
        now: value,
    }).strict(),
    readAt: z.number().int().nonnegative(),
}).strict();
